import { Component, OnInit,ViewChild, NgZone,ElementRef, Input } from '@angular/core';
import { Router} from '@angular/router';
import { CookieService } from '../_services/cookie.service';
import { ReportService } from '../inservice/report.service';
import { Title } from '@angular/platform-browser';
import { FilterService } from "primeng/api";
import Swal from 'sweetalert2';
import { Table } from 'primeng/table';
import {DatePipe} from '@angular/common';
declare var $: any;

@Component({
  selector: 'app-complete',
  templateUrl: './complete.component.html',
  styleUrls: ['./complete.component.css']
})
export class CompleteComponent implements OnInit {
	userName: string;
	userInfo:any;
	userId:string;
	r:string;
	public logOutFlag = 0;
	public showLogo = 0;
	logoInfo:any;
	rptContainer:any;
	curComments="";
	selectComm:any;
	commOrder=[];
	fromDate: Date;
	toDate: Date;
	cols: any[];
	cols2: any[];
	_selectedColumns: any[];
	selectedDisplayCols: any[];
	reports=[];
	numReports = 0;
	photos=[];;
	others=[];
	logos=[];
	bks=[];
	pmList=[];
	statusList=[];
	imgGroup='other';
	uploadFiles=0;
	uploadTotal=0;
	uploadNo=0;
	uploadedFiles=[];
	loading=false;
	uploadType:string;
	currentRowData:any
	keyInput='';
	value: Date;
	isErisStaff: any;
	acceptType=[];
	companyGroupIndicator = false;
	@ViewChild('dt') dt: Table;

	constructor(private router: Router,private titleService:Title, private datePipe:DatePipe, private FilterService: FilterService, private cookieService: CookieService, private reportService: ReportService, private ngZone: NgZone) {
		this.reportService.stream$.subscribe(this.receiveMessage.bind(this))
		
			this.toDate = new Date();//.toISOString().slice(0, 10); console.log(this.toDate);
		this.fromDate = new Date(Date.now() - 30 * 24 * 60 * 60 * 1000);
		this.getUserDetail();
		this.FilterService.register('custom-equals', (value, filters) => {
			console.log("value", value);
			if (filters === undefined || filters === null || filters.length === 0 || filters=="Y") {
				return true;
			}
			if (value === undefined || value === null|| value.length===0) {
                return false;
            }
			return value[0].TEMPLATE_TITLE.toLowerCase().includes(filters.toLowerCase());
		});	
		this.FilterService.register('custom-contain', (value, filters) => {
			console.log("value", value);
			if (filters === undefined || filters === null || filters.length === 0 || filters=="Y") {
				return true;
			}
			if (value === undefined || value === null || value.length===0) {
                return false;
            }
			return value[0].FULL_NAME.toLowerCase().includes(filters.toLowerCase());
		});	
	

		/*FilterUtils['custom-equals'] = (value, filter): boolean => {
			console.log("value", value);
            if (filter === undefined || filter === null || filter.trim() === '') {
                return true;
            }
    
            if (value === undefined || value === null) {
                return false;
            }
            
            return value[0].TEMPLATE_TITLE.includes(filter);
        }*/		

	}

	getUserDetail() {
		if (this.cookieService.getCookie("userID")) {
			this.userInfo=JSON.parse(this.cookieService.getCookie("userInfo"));
			console.log("firstuserinfo", this.userInfo)
			this.isErisStaff = this.userInfo.ERIS_STAFF
			console.log(this.isErisStaff)
			this.userId = this.cookieService.getCookie("userID"); console.log(this.userId);
			this.userName = this.cookieService.getCookie("userName"); console.log(this.userName);
			this.r = this.cookieService.getCookie("r");
			this.getReports();
			
			this._getCompanyGroupIndicator().then(() => {
				if (this.companyGroupIndicator) {
					this.cols.push({ field: 'REPORT_GROUP', searchfield: 'REPORT_GROUP.GROUP_NAME', sortfield: 'REPORT_GROUP.GROUP_NAME', header: 'Group', width: "auto", filterMatchMode:'contains'});
					this.selectedDisplayCols.push({ field: 'REPORT_GROUP', searchfield: 'REPORT_GROUP.GROUP_NAME', sortfield: 'REPORT_GROUP.GROUP_NAME', header: 'Group', width: "auto", filterMatchMode:'contains'});
				}

				if (this.cols) {
					this.loadSelectedColumns(this.userInfo['DASHBOARD_COLUMNS']);
				}
			});
			//this.userName = this.cookieService.getCookie("userName"); console.log(this.userName);
			// this.getUserInfo();
		} else {
			//this.userId=null;			
		}
	}
	// getUserInfo(){
	// 	console.log(this.userInfo);
	// 	let inputJson={"PROCEDURE":"getrwuser","USER_ID":parseInt(this.userInfo.USER_ID),"REQUESTED_USER_ID":parseInt(this.userInfo.USER_ID)}
	// 	console.log("getuserinfo", inputJson)
	// 	this.reportService.univeralService(JSON.stringify(inputJson)).subscribe(data => {
	// 		console.log("userinfo",data);
	// 		this.userInfo=data;
	// 	})

	//   }
	public onInfo(e) {
		this.getUserDetail();
	}
	getReports(){
		 //.toISOString().slice(0, 10); console.log(this.fromDate);
		let fd = this.datePipe.transform(this.fromDate,"dd-MMM-yy"); console.log(fd)
		let td=	this.datePipe.transform(this.toDate,"dd-MMM-yy");console.log(td)
		//let inputJson={"PROCEDURE":"getcompletedreports","USER_ID":parseInt(this.userId)};{"PROCEDURE":"getcompletedreports","USER_ID":5,"FROM_DATE":"01-JUN-21","TO_DATE":"31-JUL-21"}
		let inputJson={"PROCEDURE":"getcompletedreports","USER_ID":parseInt(this.userId),"FROM_DATE":fd,"TO_DATE":td};
		console.log(JSON.stringify(inputJson));
		this.reportService.univeralService(JSON.stringify(inputJson)).subscribe(data => {
			console.log("reports",data);
			if (data.RESPONSE_STATUS=='N') {
				this.throwError(data)
				return										
			}
			this.reports=data.COMPLETED_REPORT_LIST; console.log(this.reports);
			this.numReports = this.reports.length;
			/*for(let rpt of this.reports){
				if(rpt.TRANSACTION_TYPE&&rpt.TRANSACTION_TYPE.length>0){
					rpt.TRANSACTION_TYPE[0]['FULL_NAME']=rpt.TRANSACTION_TYPE[0].TRANSACTION_TYPE;
					if(rpt.PROTOCOL&&rpt.PROTOCOL.length>0){console.log(rpt.TRANSACTION_TYPE[0]['FULL_NAME'])
						rpt.TRANSACTION_TYPE[0]['FULL_NAME']+=", "+rpt.PROTOCOL[0].PROTOCOL;
					}
					console.log(rpt.TRANSACTION_TYPE[0]['FULL_NAME'])
				}
			}*/
				for(const [j, rpt]  of data.COMPLETED_REPORT_LIST.entries()){
				
					rpt['flat']={};			
					/*if(rpt.PERCENT_COMPLETE){
						rpt.PERCENT_COMPLETE=parseFloat(rpt.PERCENT_COMPLETE.replace('%','')).toFixed(2)
					}
					if(rpt.REVIEWER_PROGRESS){
						rpt.REVIEWER_PROGRESS=parseFloat(rpt.REVIEWER_PROGRESS.replace('%','')).toFixed(2)
					}*/		
					//rpt.ASSESSORTITLE={"TITLE":rpt.ASSESSOR_TITLE};
					//rpt.REVIEWERTITLE={"TITLE":rpt.REVIEWER_TITLE};
					if(rpt.PROTOCOL&& rpt.PROTOCOL[0]){
						rpt.flat.PROTOCOL=rpt.PROTOCOL[0].PROTOCOL;
					}
					
					if(rpt.TRANSACTION_TYPE && rpt.TRANSACTION_TYPE[0]){
						rpt.flat.TRANSACTION_TYPE=rpt.TRANSACTION_TYPE[0].TRANSACTION_TYPE;
						//rpt.flat.TRANSACTION_TYPE=rpt.TRANSACTION_TYPE[0].TRANSACTION_TYPE+","+rpt.PROTOCOL[0].PROTOCOL;
						if(rpt.PROTOCOL&& rpt.PROTOCOL[0]){
							rpt.flat.TRANSACTION_TYPE+=","+rpt.PROTOCOL[0].PROTOCOL;
						}						
					}
					if(rpt.ASSESSOR && rpt.ASSESSOR[0]){
						rpt.flat.ASSESSOR=rpt.ASSESSOR[0].FULL_NAME? rpt.ASSESSOR[0].FULL_NAME : rpt.ASSESSOR[0].USER_EMAIL;
					}
					if(rpt.REVIEWER && rpt.REVIEWER[0]){
						rpt.flat.REVIEWER=rpt.REVIEWER[0].FULL_NAME? rpt.REVIEWER[0].FULL_NAME : rpt.REVIEWER[0].USER_EMAIL;
					}
					if(rpt.ASSIGNED_USERS && rpt.ASSIGNED_USERS[0]){
						rpt.flat.ASSIGNED_USERS=rpt.ASSIGNED_USERS[0].FULL_NAME;
					}
					if(rpt.TEMPLATE && rpt.TEMPLATE[0]){
						rpt.flat.TEMPLATE=rpt.TEMPLATE[0].TEMPLATE_TITLE
					}
					if(!rpt.ASSESSOR){
						
						rpt.ASESSOR=[];
					}
					if(!rpt.REVIEWER){
						rpt.REVIEWER=[];
					}
					if(!rpt.ASSIGNED_USERS){
						rpt.ASSIGNED_USERS=[];
					}				
				}
			
			$("#spin1").css('display','none');
		})
	}
	onFilter(event) {
		console.log(event);
		this.numReports = event.filteredValue.length; 
	}

	expanded=false;
	expandcollapse() {
		this.expanded =! this.expanded;
	  }

  largeColWidth = '180px' 
  medColWidth = '90px'
  largeColMinWidth = '180px' 
  medColMinWidth = '90px'
  receiveMessage(msg : string) {
	  console.log(msg); // your message from component A
   }
   geoCoder
  ngOnInit() {
	this.geoCoder = new google.maps.Geocoder;

	/*this.cols=[
		{ field: 'PROJECT_NUMBER',  searchfield: 'PROJECT_NUMBER', header: 'Project Number', width: '6%' , filterMatchMode:'contains'}, //1
		{ field: 'REPORT_TITLE', searchfield: 'REPORT_TITLE', header: 'Access Report(s)', width: '7%' , filterMatchMode:'contains', field3:'REPORT'}, //2
		{ field: 'PROPERTY_NAME',  searchfield: 'PROPERTY_NAME', header: 'Property Name', width: '6%', filterMatchMode:'contains' }, //3
		{ field: 'ADDRESS_LINE1',  searchfield: 'ADDRESS_LINE1', header: 'Property Address', width: '6%' , filterMatchMode:'contains'}, //4
		{ field: 'TEMPLATE',searchfield: 'TEMPLATE',  header: 'Template', width: '5%' , filterMatchMode:'custom-equals', field3:'TEMPLATE'}, //5
		{ field: 'ASSESSOR_DUE_DATE', searchfield: 'ASSESSOR_DUE_DATE',header: 'Writer Due Date', width: '3%' , filterMatchMode:'contains'}, //6
		{ field: 'REVIEWER_DUE_DATE',searchfield: 'REVIEWER_DUE_DATE', header: 'Reviewer Due Date', width: '3%' , filterMatchMode:'contains'}, //7
		{ field: 'REPORT_DUE_DATE',searchfield: 'REPORT_DUE_DATE', header: 'Report Due Date', width: '3%' , filterMatchMode:'contains'}, //8
		{ field: 'ASSESSOR',searchfield: 'ASSESSOR', header: 'Writer', width: '5%' , filterMatchMode:'custom-contain', field2:'FULL_NAME'}, //9
		{ field: 'REVIEWER',searchfield: 'REVIEWER', header: 'Reviewer', width: '5%' , filterMatchMode:'custom-contain', field2:'FULL_NAME'}, //10
		{ field: 'ASSIGNED_USERS',searchfield: 'ASSIGNED_USERS', header: 'Assigned User', width: '5%' , filterMatchMode:'custom-contain', field2:'FULL_NAME'}, //11
		{ field: 'TRANSACTION_TYPE',searchfield:'TRANSACTION_TYPE', header: 'Transaction Protocol', width: '4%' , filterMatchMode:'custom-contain', field2:'TRANSACTION_TYPE'}, //12
		{ field: 'STATUS',searchfield: 'STATUS', header: 'Status', width: '5%' , filterMatchMode:'contains'}, 
		{ field: 'ORDER_NUM', searchfield: 'ORDER_NUM',header: 'ERIS Data', width: '4%' , filterMatchMode:'contains'}, //13
		{ field: 'DATE_UPDATED', searchfield: 'DATE_UPDATED',header: 'Last Edited', width: '4%' , filterMatchMode:'contains'}, //13
		{ field: 'DATE_CREATED', searchfield: 'DATE_CREATED',header: 'Created Date', width: '4%' , filterMatchMode:'contains'},
		{ field: 'PROJECT_MANAGER', searchfield: 'PROJECT_MANAGER',header: 'More Info', width: '4%' , filterMatchMode:'contains'},
	];*/
	this.largeColWidth
	
	// width of first column is determined by total number of columns, if you add/remove a column remember to change the width of the 1st column:
	this.cols=[
		// { field: 'PROJECT_MANAGER', searchfield: 'PROJECT_MANAGER',header: '', width: '5%', filterMatchMode:'contains'},
		{ field: 'GROUP_LABEL', searchfield: 'GROUP_LABEL', sortfield: 'GROUP_LABEL', header: '', width: `${100/17}%`, filterMatchMode:'contains' },
		{ field: 'PROJECT_NUMBER',  searchfield: 'PROJECT_NUMBER', sortfield:'PROJECT_NUMBER', header: 'Project Number', width: 'auto', filterMatchMode:'contains'}, //1
		{ field: 'REPORT_TITLE', searchfield: 'REPORT_TITLE', sortfield:'REPORT_TITLE', header: 'Access Report(s)', width: 'auto', filterMatchMode:'contains', field3:'REPORT'}, //2
		{ field: 'PROPERTY_NAME',  searchfield: 'PROPERTY_NAME', sortfield:'PROPERTY_NAME', header: 'Property Name', width: 'auto', filterMatchMode:'contains' }, //3
		{ field: 'FULL_ADDRESS',  searchfield: 'FULL_ADDRESS', sortfield:'FULL_ADDRESS', header: 'Property Address', width: 'auto', filterMatchMode:'contains'}, //4
		{ field: 'TEMPLATE',searchfield: 'flat.TEMPLATE', sortfield:'flat.TEMPLATE',  header: 'Template', width: 'auto', filterMatchMode:'contains', field3:'TEMPLATE'}, //5
		{ field: 'ASSESSOR_DUE_DATE', searchfield: 'ASSESSOR_DUE_DATE', sortfield:'ASSESSOR_DUE_DATE',header: 'Writer Due Date', width: 'auto', filterMatchMode:'contains'}, //6
		{ field: 'REVIEWER_DUE_DATE',searchfield: 'REVIEWER_DUE_DATE', sortfield:'REVIEWER_DUE_DATE', header: 'Reviewer Due Date', width: 'auto', filterMatchMode:'contains'}, //7
		{ field: 'REPORT_DUE_DATE',searchfield: 'REPORT_DUE_DATE', sortfield:'REPORT_DUE_DATE', header: 'Report Due Date', width: 'auto', filterMatchMode:'contains'}, //8
		{ field: 'ASSESSOR',searchfield: 'flat.ASSESSOR', sortfield:'flat.ASSESSOR', header: 'Writer', width: 'auto', filterMatchMode:'contains', field2:'FULL_NAME'}, //9
		{ field: 'REVIEWER',searchfield: 'flat.REVIEWER', sortfield:'flat.REVIEWER', header: 'Reviewer', width: 'auto', filterMatchMode:'contains', field2:'FULL_NAME'}, //10
		{ field: 'ASSIGNED_USERS',searchfield: 'flat.ASSIGNED_USERS', sortfield:'flat.ASSIGNED_USERS', header: "Add'l User(s)", width: 'auto',  filterMatchMode:'contains', field2:'FULL_NAME'}, //11
		{ field: 'TRANSACTION_TYPE',searchfield:'flat.TRANSACTION_TYPE', sortfield:'flat.TRANSACTION_TYPE', header: 'Transaction Protocol', width: 'auto', filterMatchMode:'contains', field2:'TRANSACTION_TYPE'}, //12
		{ field: 'STATUS',searchfield: 'STATUS', sortfield:'STATUS', header: 'Status', width: 'auto', filterMatchMode:'contains'}, 
		{ field: 'ORDER_NUM', searchfield: 'ORDER_NUM', sortfield:'ORDER_NUM',header: 'ERIS Data', width: 'auto', filterMatchMode:'contains'}, //13
		{ field: 'DATE_UPDATED', searchfield: 'DATE_UPDATED', sortfield: 'DATE_UPDATED',header: 'Last Edited', width: 'auto', filterMatchMode:'contains'}, //13
		{ field: 'DATE_CREATED', searchfield: 'DATE_CREATED', sortfield: 'DATE_CREATED',header: 'Created Date', width: 'auto', filterMatchMode:'contains'},
		{ field: 'CLIENT_COMPANY_NAME', searchfield: 'CLIENT_COMPANY_NAME', sortfield: 'CLIENT_COMPANY_NAME', header: 'Client', width: "auto", filterMatchMode:'contains'}, //20
	];
	// we don't want user to be able to disable the first three columns:
	this.selectedDisplayCols = this.cols.filter(col => !['GROUP_LABEL','PROJECT_NUMBER','REPORT_TITLE'].includes(col.field));
	if (this.userInfo) {
		this.loadSelectedColumns(this.userInfo['DASHBOARD_COLUMNS']); // this is for the select columns multiselect
	}

	this.cols2 = [			
		//{ field: 'SLOT_ID', header: 'Id' },
		 { field: 'FILE_NAME', header: 'File Name', width: '20%' },
		{ field: 'FILE_TYPE', header: 'File Type', width: '11%' },
		{ field: 'PROJECT_ID', header: 'Project Name', width: '15%' },
		{ field: 'REPORT_CATEGORY', header: 'Report Type ' , width: '14%' },
		{ field: 'UPDATED_BY', header: 'Upload By ' , width: '12%' },
		{ field: 'DATE_UPDATED', header: 'Date ' , width: '8%' },
			
	];
	  
  }
 
	
	public orderTrackBy(index: number) {
     
	}
	/*public showComment(orderNo, text, event){
		console.log(text);
		this.curComments=text;
		this.commOrder=orderNo;
		this.selectComm=$(event.target);
	}
	public read(){
		let orderno=this.commOrder.join(',');
		let inputJson={"PROCEDURE":"setAlert","ORDER_NUM":orderno,"IS_ALERT":"N","USERNAME":this.data};
		console.log(inputJson);
		this.serviceCall1(JSON.stringify(inputJson));
	}
	public cancel(){
		let orderno=this.commOrder.join(',');
		let inputJson={"PROCEDURE":"setAlert","ORDER_NUM":orderno,"IS_ALERT":"Y","USERNAME":this.data};
		console.log(inputJson);
		this.serviceCall1(JSON.stringify(inputJson))
	}
	public toViewer(info,k){
		this.router.navigate(['/usgeoref'],{ queryParams: { orderno: info.ORDER_NUM[k] }});	
	}*/
	public search(){
		$("#spin1").css('display','inline-block');
		this.getReports();			
	}
	logOut() {
		this.logOutFlag++; console.log(this.logOutFlag);
	}
	onSavedLogo(e) {
		this.showLogo = e;

	}
	onEditReport(e) {

	}

	index(obj,i) {return obj[i]}
	projectCols=[
		{field: 'PROJECT_NUMBER', searchfield: '', header: 'Project Number'},
		{field: 'PROPERTY_NAME', searchfield: '', header: 'Property Name'},
		{field: 'FULL_ADDRESS', searchfield: '', header: 'Property Address'},
		{field: 'CHARGE_AMOUNT', searchfield: '', header: 'Project Cost'},
		{field: 'EXPENSE_AMOUNT', searchfield: '', header: 'Project Expense'},
		{field: 'TOTAL_AMOUNT', searchfield: '', header: 'Project Total'},
		{field: 'CLIENT_COMPANY_NAME', searchfield: '', header: 'Client Company Name'},
	]
	async checkUser(){
		let inputJson={"PROCEDURE":"checkuserpermission","USER_ID":parseInt(this.userId),"FUNCTION_ID":1};
		const response = await this.reportService.univeralService(JSON.stringify(inputJson)).toPromise();
		return response;
	}
	async exportExcel(proOnly?){
		let response=await this.checkUser();
		if(response.RESPONSE_STATUS=="N"){
			this.throwError(response);
			return
		}else if(response.USER_PERMISSION=='N'){
				Swal.fire({
					icon:'warning',
					title: response.MESSAGE,
				})
			return
		}
		let excelData;
		if (this.dt.filteredValue) {
			excelData = this.dt.filteredValue
		} else {
			excelData = this.dt.value;
		}
		console.log(excelData)
		
		let table={
			"header":[],
			"data":[]
		}
		let filetitle="Project and Reports (Complete)";
		if(proOnly){
			filetitle="Project Only (Complete)";
			let i = 1;
			for(let col of this.projectCols){
				table.header.push({"headername":col.header, "col": i.toString()})
				i++
			}
			let allPro=[];
			for(let i=0;i<excelData.length+1;i++){
				if(excelData[i]){
					let proIndex=allPro.indexOf(excelData[i].PROJECT_ID);
					if(proIndex>-1){
						continue
					}else{
						allPro.push(excelData[i].PROJECT_ID)
					}
				
					let arr=[];
					let j = 1
					for(let col of this.projectCols){
						let obj={"col":j.toString(), "datavalue": excelData[i][col.field], "dtype":"string"};
						// console.log(obj)
						if(obj.datavalue){
							arr.push(obj);
						}
						
						j++
					}
					table.data.push({"row":arr});
				}
			}
		}else{
				let i = 1;
				for(let col of this.cols){
					table.header.push({"headername":col.header, "col": i.toString()});
					i++;
				}
				for(let i=1; i<excelData.length+1; i++){
					let arr=[];
					let j = 1;
					// console.log(excelData[i-1])

					for(let col of this.cols){
						let obj = {
							"col": j.toString(),
							"datavalue": col.searchfield.split('.').reduce(this.index, excelData[i-1]),
							"dtype":"string"
						};
						// console.log(obj);
						if (col.field == "ASSESSOR" || col.field == "REVIEWER" || col.field == "ASSIGNED_USERS") {
							let arr=[]
							// for some reason sometimes the users from oracle are undefined:
							if (excelData[i-1][col.field] !== undefined) {
								for(let user of excelData[i-1][col.field]){
									arr.push(user.FULL_NAME? user.FULL_NAME : user.USER_EMAIL);
								}
							}
							obj.datavalue=arr.join(", ")
						}
						if (col.field == "CONSULTANT_LOCATION") {
							obj.datavalue = excelData[i-1][col.field].LOCATION_NAME
						}
						if(col.field=="TRANSACTION_TYPE"){
							if(excelData[i-1][col.field][0]){
								obj.datavalue = excelData[i-1][col.field][0].TRANSACTION_TYPE
								if(excelData[i-1]["PROTOCOL"][0]){
									obj.datavalue	+= ', '+excelData[i-1]["PROTOCOL"][0].PROTOCOL;
								}
							}else if(excelData[i-1]["PROTOCOL"][0]){
								obj.datavalue =  excelData[i-1]["PROTOCOL"][0].PROTOCOL;
							}
							
						}
						if (obj.datavalue) {
							arr.push(obj);
						}
						
						j++;
					}
					table.data.push({"row":arr});
				}
		}
		console.log('table', table);

		let inputJson={"USER_ID":parseInt(this.userId), "COMPANY_ID":this.userInfo.COMPANY_ID?.toString() ,"filetitle":filetitle, "exceljson":JSON.stringify(table)};
		// console.log("exportExcel", inputJson);
		this.reportService.genExcel(JSON.stringify(inputJson)).subscribe(data => {
			// console.log(data);
			window.open(data.fileurl);
		})
	}
	showPhotosTab = false;
	getAllBk(pid, reportID){
		//let inputJson={"PROCEDURE":"getallbkimages", "USER_ID":id};console.log(inputJson);
		// let inputJson2={"PROCEDURE":"getprojectphotos","USER_ID":parseInt(this.userId),"PROJECT_ID":pid}
		// this.reportService.univeralService(JSON.stringify(inputJson2)).subscribe(data => {
		// 	console.log(data);
		// 	this.photos=data.RW_UPLOAD_FILES;
		// })
		// only show photos tab if it is a report:
		if (reportID !== undefined) {
			let inputJson2={"PROCEDURE":"GetPhotosByReport","USER_ID":parseInt(this.userId),"REPORT_ID":reportID}
			this.reportService.univeralService(JSON.stringify(inputJson2)).subscribe(data => {
				console.log(data);
				if (data.RESPONSE_STATUS=='N') {
					this.throwError(data)
					return										
				}
				this.photos=data.RW_UPLOAD_FILES;
			})
			this.showPhotosTab = true;
		} else {
			this.photos=[];
			this.showPhotosTab = false;
		}
		let inputJson3={"PROCEDURE":"getfilesbyproject","USER_ID":parseInt(this.userId),"PROJECT_ID":pid};
		//let inputJson1={"PROCEDURE":"getallcompanyimages", "COMPANY_ID":this.userInfo.COMPANY_ID.toString(), "BK_IMAGE_IND":"N"};
		this.reportService.univeralService(JSON.stringify(inputJson3)).subscribe(data => {
			console.log(data);
			if (data.RESPONSE_STATUS=='N') {
				this.throwError(data)
				return										
			}
			this.uploadedFiles=data.RW_UPLOAD_FILES;
		})
		let inputJson={"PROCEDURE":"getcompanyfiles","USER_ID":parseInt(this.userId),"FILE_TYPE":"BKIMAGE"}
		console.log(inputJson);
		this.reportService.univeralService(JSON.stringify(inputJson)).subscribe(data => {
			console.log(data);
			if (data.RESPONSE_STATUS=='N') {
				this.throwError(data)
				return										
			}
			this.bks=data.RW_UPLOAD_FILES;
		})
		let inputJson1={"PROCEDURE":"getcompanyfiles","USER_ID":parseInt(this.userId),"FILE_TYPE":"IMAGE"}
		console.log(inputJson1);
		this.reportService.univeralService(JSON.stringify(inputJson1)).subscribe(data => {
			console.log(data);
			if (data.RESPONSE_STATUS=='N') {
				this.throwError(data)
				return										
			}
			this.others=data.RW_UPLOAD_FILES;
		})
	} 
	 updateFile(item, type, e? ){console.log(item);
		let data=$(e.target).prev('textarea').val();console.log(data);
		let inputJson={"PROCEDURE":"updateuploadfilev2","USER_ID":parseInt(this.userId),"FILE_ID":item.FILE_ID,"FILE_NAME":item.FILE_NAME,"FILE_DESCRIPTION":data};
		console.log(inputJson);
		this.reportService.univeralService1(JSON.stringify(inputJson)).subscribe(response => {
			console.log(response)
			let file=JSON.parse(response);
			if (file.RESPONSE_STATUS=='N') {
				this.throwError(file)
				return										
			}
			if(type=='PHOTO'){
				let index=this.photos.findIndex(photo=>photo.FILE_ID==file.FILE_ID);
				if(index>-1){
					this.photos[index]=file;
				}
			}else if(type=='IMAGE'){
				let index=this.others.findIndex(other=>other.FILE_ID==file.FILE_ID);
				if(index>-1){
					this.others[index]=file;
				}
			}else if(type=='BKIMAGE'){
				let index=this.bks.findIndex(bk=>bk.FILE_ID==file.FILE_ID);
				if(index>-1){
					this.bks[index]=file;
				}
			}else if(type=='LOGO'){
				let index=this.logos.findIndex(logo=>logo.FILE_ID==file.FILE_ID);
				if(index>-1){
					this.logos[index]=file;
				}
			}
		})
	}
	deleteFile(item, type){
		console.log(item)
		let that=this;
		Swal.fire({
			icon:'warning',
			title: 'Are you sure you want to delete this item?',
			confirmButtonText: 'Delete',
			showLoaderOnConfirm: true,
			showCancelButton: true,
			backdrop:false,
			preConfirm: () => {
				let inputJson={"PROCEDURE":"deleteuploadfilev2","USER_ID":parseInt(that.userId),"FILE_ID":item.FILE_ID};
				this.reportService.univeralService1(JSON.stringify(inputJson)).subscribe(response => {
					console.log(JSON.parse(response))
					if (JSON.parse(response).RESPONSE_STATUS=='N') {
						this.throwError(JSON.parse(response))
						return										
					}
					if(JSON.parse(response).RESPONSE_STATUS=="Y"){
						let data=[];
						if(type=="FILE"){
							data=that.uploadedFiles
						}else if(type=="PHOTO"){
							data=that.photos
						}else if(type=="IMAGE"){
							data=that.others
						}else if(type=="BKIMAGE"){
							data=that.bks
						}else if(type=="LOGO"){
							data=that.logos
						}
						let index=data.findIndex(file=>file.FILE_ID==item.FILE_ID); console.log(index);
						if(index>-1){
							data.splice(index,1);
							Swal.fire({
								icon:'success',
								title: JSON.parse(response).MESSAGE,
							})
						}
					}
					this.getAllBk(item.PROJECT_ID, item.REPORT_ID)
				})
			}
		})
	}
	public upload(type?) {console.log(type)
		//$("#uploadModal").modal('show');
		if(type){
			this.uploadType=type;
		}
		if(this.uploadType=='PHOTO'||this.uploadType=='IMAGE'||this.uploadType=='LOGO'||this.uploadType=='BKIMAGE'){
			$("#"+ this.currentRowData.REPORT_ID.toString()).click();
		}else if(this.uploadType=='FILE'){
			$("#"+this.currentRowData.REPORT_ID.toString()+"x").click();
		}
	}
	hasPM
	PMname = 'test'
	checkPM(rowData){
		console.log(rowData)
		if(rowData.PROJECT_MANAGER.length==0){
			this.hasPM = false
		} else {
			this.hasPM = true
			this.PMname = rowData.PROJECT_MANAGER[0].FULL_NAME
		}
	}
	getProM(){
		if(this.pmList.length>0) return;
		let newinputJson={"PROCEDURE":"getcompanyuserlist", "USER_ID":parseInt(this.userId), "INCLUDE_EXTERNAL":"N"}; // hardcoded for now 
		this.reportService.univeralService(JSON.stringify(newinputJson)).subscribe(data => {
			console.log(data);
			if (data.RESPONSE_STATUS=='N') {
				this.throwError(data)
				return										
			}
			this.pmList=data.RW_USERS;console.log('pmList',this.pmList);
		})
	}
	updatePM(e, data){console.log(data)
		let id=parseInt($(e.target).prev().val());
		if(id>-1){
		let inputJson={"PROCEDURE":"updatereport", "USER_ID": parseInt(this.userId),  "PROJECT_ID":data.PROJECT_ID, 'REPORT_ID':data.REPORT_ID, "PROJECT_MANAGER_ID":id};
			console.log("updatePM", inputJson);
			this.reportService.univeralService(JSON.stringify(inputJson)).subscribe(response => {
				console.log(response);
				let Toast=Swal.mixin({
						toast: true,						
						position: 'center',
						showConfirmButton: false,
						timer: 3000
					})
				if(response.RESPONSE_STATUS=='Y'){
					data.PROJECT_MANAGER[0]=response.PROJECT_MANAGER[0];
					Toast.fire({
						icon: 'success',
						title: response.MESSAGE
					})
				}else{
					this.throwError(response)
				}
				
			})
		}
	}
	uploadFile2(rowdata){
		console.log("rowdata",rowdata)
		let that=this;
		this.uploadFiles=0;
		this.uploadNo=0;
		const files = $("#"+this.currentRowData.REPORT_ID.toString()+"x").prop("files"); console.log(files);
		if(files.length==0){
			this.loading=false;
		return
		}
		for (let file of files){  //for multiple files
		 	const ext = file.name.replace(/.+\./, '');
			if (this.acceptType.indexOf(ext) === -1) {
				Swal.fire('Oops...', ext + ' file Type is not acceptable..');
				this.loading=false;
				return;
			}
		}
		const total=files.length;
		this.uploadNo=total;
		for (let file of files)  //for multiple files
		{
			let reader = new FileReader();  
			reader.onloadend = function(e) {
				
				let filedata = e.target.result.toString().split(',')[1];//
				let inputJson={"filename":file.name,"user_id":that.userId,"report_id":rowdata.REPORT_ID,"project_id":rowdata.PROJECT_ID,"file_desc":"","file_type":"FILE","filetitle":"","fdata":filedata}
				console.log(inputJson);
				that.reportService.uploadFile2(inputJson).subscribe(result=>{console.log(result);
					console.log(result);
					if (result.RESPONSE_STATUS=='N') {
						that.throwError(result);
						return										
					}
					that.uploadedFiles.push(result);
					that.uploadFiles++
					that.uploadTotal=(that.uploadFiles/total)*100; //console.log(that.uploadTotal)
										
				})		
			console.log(inputJson)
			//that.reportService.uploadBkService(inputJson).subscribe(result=>{
			
		}
		reader.readAsDataURL(file);
		} 
  }
  public uploadImage(rowdata) {console.log(rowdata);
	let that=this;
	console.log("Test")
	this.uploadFiles=0;
		this.uploadNo=0;
    //const file = $(rowdata.REPORT_ID.toString()).files[0];
	const files = $("#"+rowdata.REPORT_ID.toString())[0].files; console.log(files);
    /*$(rowdata.REPORT_ID.toString()).value = null;
    const ext = file.name.replace(/.+\./, '');
    if (['png','PNG', 'jpg','JPG', 'jpeg','JPEG'].indexOf(ext) === -1) {
      Swal.fire('Oops...', 'Only support .png|.jpg|.jpeg', 'error');
      return;
    }*/
	 if(files.length==0){
		this.loading=false;
      return
    }
	const total=files.length;
		this.uploadNo=total;
	 for(let i=0; i<files.length; i++){console.log(files[0]);
      //$(rowdata.REPORT_ID.toString()).value = null;
      const ext = files[i].name.replace(/.+\./, '');
		if (this.acceptType.indexOf(ext) === -1) {
			Swal.fire('Oops...', ext + ' file Type is not acceptable..');
			this.loading=false;
			return;
		}
    }
    //this.fileReader.readAsDataURL(file);
	for (let file of files)  //for multiple files
    {   
		
		let reader = new FileReader();  
        reader.onloadend = function(e) {
			let image = e.target.result.toString().split(',')[1]; //upload service
			let inputJson:any;
					
			if(that.uploadType=='BKIMAGE'){console.log('bk image');
				//inputJson={"UploadFileName":file.name,"customerid":that.userId,"logoData":image};
				inputJson={"filename":file.name,"user_id":that.userId,"company_id":that.userInfo.COMPANY_ID?.toString(),"report_id":rowdata.REPORT_ID?.toString(),"project_id":rowdata.PROJECT_ID?.toString(),"file_desc":"","file_type":"BKIMAGE","filetitle":"","fdata":image};
				console.log(inputJson);
				that.reportService.uploadFile2(inputJson).subscribe(result=>{console.log(result);
					console.log(result);
					if (result.RESPONSE_STATUS=='N') {
						that.throwError(result);
						return										
					}
					that.bks.push(result);
					that.uploadFiles++	
					that.uploadTotal=(that.uploadFiles/total)*100; //console.log(that.uploadTotal)
								
			})
			}else if(that.uploadType=='PHOTO'){console.log('report image');
				inputJson={"filename":file.name,"user_id":that.userId,"company_id":that.userInfo.COMPANY_ID?.toString(),"report_id":rowdata.REPORT_ID?.toString(),"project_id":rowdata.PROJECT_ID?.toString(),"file_desc":"","file_type":"PHOTO","filetitle":"","fdata":image};
				console.log(inputJson);
				that.reportService.uploadFile2(inputJson).subscribe(result=>{console.log(result);
					console.log(result);
					if (result.RESPONSE_STATUS=='N') {
						that.throwError(result);
						return										
					}
					that.photos.push(result);
					that.uploadFiles++
					that.uploadTotal=(that.uploadFiles/total)*100; //console.log(that.uploadTotal)
					
								
			})
			}else if(that.uploadType=='IMAGE'){console.log('other image');
				inputJson={"filename":file.name,"user_id":that.userId,"company_id":that.userInfo.COMPANY_ID?.toString(),"report_id":rowdata.REPORT_ID?.toString(),"project_id":rowdata.PROJECT_ID?.toString(),"file_desc":"","file_type":"IMAGE","filetitle":"","fdata":image};
				console.log(inputJson);
				that.reportService.uploadFile2(inputJson).subscribe(result=>{console.log(result);
					console.log(result);
					if (result.RESPONSE_STATUS=='N') {
						that.throwError(result);
						return										
					}
					that.others.push(result);
					that.uploadFiles++
					that.uploadTotal=(that.uploadFiles/total)*100; //console.log(that.uploadTotal)
					
			})
			}else if(that.uploadType=='LOGO'){console.log('LOGO image');
				inputJson={"filename":file.name,"user_id":that.userId,"company_id":that.userInfo.COMPANY_ID.toString(),"report_id":rowdata.REPORT_ID.toString(),"project_id":rowdata.PROJECT_ID.toString(),"file_desc":"","file_type":"LOGO","filetitle":"","fdata":image};
				console.log(inputJson);
				that.reportService.uploadFile2(inputJson).subscribe(result=>{console.log(result);
					console.log(result);
					if (result.RESPONSE_STATUS=='N') {
						that.throwError(result);
						return										
					}
					that.logos.push(result);
					that.uploadFiles++
					that.uploadTotal=(that.uploadFiles/total)*100; //console.log(that.uploadTotal)
					
			})
			}
			console.log(inputJson)
			//that.reportService.uploadBkService(inputJson).subscribe(result=>{
			
		}
		reader.readAsDataURL(file);
		}
		this.getAllBk(rowdata.PROJECT_ID, rowdata.REPORT_ID)
  }
  	keySearchLoading
	keySearch(){console.log(this.keyInput);
		if(this.keyInput.length>0){
			//let inputJson={"PROCEDURE":"searchcompletedreports","USER_ID":parseInt(this.userId),"SEARCH_BY":this.keyInput};
			let inputJson={"PROCEDURE":"searchreportsv2","USER_ID":parseInt(this.userId),"SEARCH_BY":this.keyInput};
			this.keySearchLoading = true
			this.reportService.univeralService(JSON.stringify(inputJson)).subscribe(response => {
				this.keySearchLoading = false
				console.log(response);
				if(response.RESPONSE_STATUS=='Y'){
					//this.reports=response.COMPLETED_REPORT_LIST;

					this.reports=response.REPORT_LIST;

					// we need this for exportExcel:
					for (let report of this.reports) {
						report['flat'] = {};
						if (report.TEMPLATE && report.TEMPLATE[0]) {
							report['flat']['TEMPLATE'] = report.TEMPLATE[0].TEMPLATE_TITLE;
						} else {
							report['flat']['TEMPLATE'] = '';
						}
					}

					this.numReports=response.REPORT_TOTAL;
					//this.keyInput='';
				}else{
					this.throwError(response);
				}
			})
		}else{
			this.getReports();
		}
	}

	@Input() get selectedColumns(): any[] {
        return this._selectedColumns
    }

    set selectedColumns(val: any[]) {
        //restore original order
		let valheaders = val.map(col=>col.header);
		let permanent = ['GROUP_LABEL', 'PROJECT_NUMBER', 'REPORT_TITLE'];
        this._selectedColumns = this.cols.filter(col => valheaders.includes(col.header) || permanent.includes(col.field));
    }

	// we need translation because the cookie storage of columns is based on the fields of the active dashboard
	// the fields from the active dashboard are different than here, so we need to translate between them
	translation = {
		'GROUP_LABEL': 'GROUP_LABEL',
		'PROJECT_NUMBER': 'PROJECT_NUMBER',
		'REPORT_TITLE': 'REPORT_TITLE',
		'PROPERTY_NAME': 'PROPERTY_NAME',
		'FULL_ADDRESS': 'FULL_ADDRESS',
		'TEMPLATE': 'TEMPLATE_ID', //
		'TEMPLATE_ID': 'TEMPLATE', //
		'ASSESSOR_DUE_DATE': 'ASSESSOR_DATE', //
		'REVIEWER_DUE_DATE': 'REVIEWER_DATE', //
		'REPORT_DUE_DATE': 'REPORT_DATE', //
		'ASSESSOR_DATE': 'ASSESSOR_DUE_DATE', //
		'REVIEWER_DATE': 'REVIEWER_DUE_DATE', //
		'REPORT_DATE': 'REPORT_DUE_DATE', //
		'ASSESSOR': 'ASSESSOR',
		'REVIEWER': 'REVIEWER',
		'ASSIGNED_USERS': 'ASSIGNED_USERS',
		'TRANSACTION_TYPE': 'TRANSACTION_TYPE',
		'STATUS': 'STATUS',
		'ORDER_NUM': 'ORDER_REPORTS',
		'ORDER_REPORTS': 'ORDER_NUM', //
		'DATE_UPDATED': 'DATE_UPDATED',
		'DATE_CREATED': 'DATE_CREATED',
		'CLIENT_COMPANY_NAME': 'CLIENT_COMPANY_NAME',
		'REPORT_GROUP': 'REPORT_GROUP'
	}
	saveSelectedColumns() {

		let converted_columns_arr = this._selectedColumns.map(col => this.translation[col.field])

		// need to do this since there are some columns that exist on active dashboard but not complete:
		let all = this.cols.map(col => this.translation[col.field])
		let existing = this.userInfo['DASHBOARD_COLUMNS'].split(',');
		existing.forEach(element => {
			if (!all.includes(element)){
				converted_columns_arr.push(element);
			}
		});
		let converted_columns = converted_columns_arr.join(); // convert array to string for oracle

		let inputJson = {
			"PROCEDURE":"updaterwuser",
			"USER_ID":parseInt(this.userId),
			"UPDATE_USER_ID":parseInt(this.userId),
			"DASHBOARD_COLUMNS": converted_columns,
		};
		console.log('saveSelectedColumns', inputJson);
		this.reportService.univeralService(JSON.stringify(inputJson)).subscribe(data=>{
			if (data.RESPONSE_STATUS === 'N') {
				this.throwError(data);
			} else {
				this.userInfo['DASHBOARD_COLUMNS'] = converted_columns;
				this.cookieService.setCookieSession("userInfo",JSON.stringify(this.userInfo));
			}
		});
	}
	loadSelectedColumns(columns) {
		if (columns === undefined || columns === "*") {
			this._selectedColumns = this.cols;
		} else {
			let converted_columns = columns.split(',');
			this._selectedColumns = this.cols.filter(col => converted_columns.includes(this.translation[col.field]));
		}
	}

	getStatus(id){
		let inputJson={"PROCEDURE":"getreportstatuslist", "USER_ID":parseInt(this.userId), "REPORT_ID":id}
			this.reportService.univeralService(JSON.stringify(inputJson)).subscribe(data => {
				console.log("Status", data);
				if (data.RESPONSE_STATUS=='N') {
					this.throwError(data)
					return										
				}
				this.statusList=data.RW_STATUS_LIST ;
			
			})
	}
	public changeStatus(rowdata, status){
		console.log(rowdata);
		// first check if user has permission:
		let checkUserInputJson={"PROCEDURE":"checkuserpermission", "USER_ID":this.userId, "REPORT_ID":rowdata.REPORT_ID, "FUNCTION_ID": status!='Final'? 12 : 13};
		console.log(checkUserInputJson);
		this.reportService.univeralService(JSON.stringify(checkUserInputJson)).subscribe(checkResponse => {
			console.log(checkResponse)
			if (checkResponse.RESPONSE_STATUS=='N') {
				this.throwError(checkResponse)
				return										
			}
			if (checkResponse.USER_PERMISSION == 'N') {
				this.throwError(checkResponse)
			} else {
				if(status=='Inactive'){
					Swal.fire({
						icon:'warning',
						html: '<span style="font-size:20px; font-weight:bold">Warning!</span><br>Once a report is INACTIVE, you may not change the status again. You will lose access to the report.<br>Only change a report to INACTIVE if you need to set up a new report using the same Template Identifier.',
						confirmButtonText: 'Confirm',
						showLoaderOnConfirm: true,
						showCancelButton: true,
						backdrop:false,
						preConfirm: () => {
							this.setStatus(rowdata, status);							
						}
					})
				}else{
					this.setStatus(rowdata, status)
				}
				
			}
		});
	}
	setStatus(rowdata, status){
		let inputJson={"PROCEDURE":"setreportstatus","USER_ID":parseInt(this.userId),"REPORT_ID":rowdata.REPORT_ID, "STATUS":status};
		console.log(inputJson);	
		this.reportService.univeralService(JSON.stringify(inputJson)).subscribe(response=>{
			console.log(response);
			//this.getStatusCounts();	
			if (response.RESPONSE_STATUS=='N') {
				this.throwError(response)
				return										
			}
			rowdata.STATUS=status;	
		})
	}
	shareEmail;
	shareByEmail(id){
		if(this.shareEmail.length<3){
			return
		}
		this.generatepdf(id); 
		/*let inputJson={"PROCEDURE":"sharereportbyemail","USER_ID":parseInt(this.userId),"REPORT_ID":id,"SHARE_EMAIL":this.shareEmail}
		this.reportService.univeralService(JSON.stringify(inputJson)).subscribe(data=>{
			console.log(data);
			if(data.RESPONSE_STATUS=='Y'){
				Swal.fire({
					title:"Success",
					html: '<p style="font-size:16px;">'+data.MESSAGE+ '</p>',
					//timer: 3000,
					showConfirmButton:true,
				   // timerProgressBar: true,
	  
				  })
			}else{
				this.throwError(data.MESSAGE);
			}

		})*/


	}
	sharecontents=[];
	sharefrontpages=[];
	shareappendices={'SECTION_SEQUENCE': "",'SECTION_TITLE': 'APPENDICES','SUB_SECTIONS':[]};;
	sharereportInfo:any;
	sharelpagesize:string;
	blackText=false;
	sharepdfs=[];
	shareerisPdfs=[];
	allRptSlots=[];
	sharepdfType:any
	toprintIndex=0;
	noPrint=false;
	sharing=false;
	sharePOP='N';
	endPdf(e){
		let inputJson={"PROCEDURE":"sharereportbyemail","USER_ID":parseInt(this.userId),"REPORT_ID":parseInt(e),"SHARE_EMAIL":this.shareEmail}
				this.reportService.univeralService(JSON.stringify(inputJson)).subscribe(data=>{
					console.log(data);
					if(data.RESPONSE_STATUS=='Y'){
						Swal.fire({
							title:"Success",
							html: '<p style="font-size:16px;">'+data.MESSAGE+ '</p>',
							//timer: 3000,
							showConfirmButton:true,
						// timerProgressBar: true,
			
						})
					}else{
						this.throwError(data);
					}

				})
	}
	pdfSpin(e){
		if(e=='start'){
			this.noPrint=true;
		}else{
			this.noPrint=false;
		}
		
	}
	showErrMsg(e){
		let info={'MESSAGE':e};
		this.throwError(e);
	}
	async getRptSlots(id){
		
		let tempJson={"PROCEDURE":"getslotsbyreportnocategory", "USER_ID":parseInt(this.userId), "REPORT_ID":id};
		
		const response = await this.reportService.univeralService(JSON.stringify(tempJson)).toPromise();
		
		if(response.RESPONSE_STATUS=="N"){
			this.throwError(response)			
			$('#overlay').css('display','none');
		}else{
			
			this.allRptSlots=response.RW_SLOTS; 
		}
	}
	async generatepdf(id){
		this.noPrint=true;
		await this.getRptSlots(id);
		let inputJson={"PROCEDURE":"getreportdata","REPORT_ID":id,"USER_ID":parseInt(this.userId),"VERSION_ID":null};
		let data= await this.reportService.univeralService(JSON.stringify(inputJson)).toPromise();	console.log('otherdata',data);
		if (data.RESPONSE_STATUS === 'N') {
			this.throwError(data);
		} else {
			if((data.REPORT_DATA&&data.REPORT_DATA.length>0)||(data.BEFORE_TOC&&data.BEFORE_TOC.length>0)){
				if(data.REPORT_DATA.length>0){
					this.sharecontents=JSON.parse(data.REPORT_DATA); //console.log('content',this.contents);
				}else{
					this.sharecontents=[];
				}
				
				if(data.BEFORE_TOC.length>0){
					this.sharefrontpages=JSON.parse(data.BEFORE_TOC); //console.log('content',this.contents);
				}else{
					this.sharefrontpages=[];
				}
				//this.sharefrontpages=JSON.parse(data.BEFORE_TOC);
				let inputJson1= {"PROCEDURE":"getreport", "USER_ID":parseInt(this.userId), "REPORT_ID":id};
				let response =await this.reportService.univeralService(JSON.stringify(inputJson1)).toPromise();
				if (response.RESPONSE_STATUS=='N') {
					this.throwError(response)
					return										
				}
							this.sharereportInfo=response;
							if(response.REPORT_PDF_SETTING){
								let setInfo=JSON.parse(response.REPORT_PDF_SETTING);
								if(setInfo.pagesize){
									this.sharelpagesize=setInfo.pagesize;
								}						
							}
								
							if(response.PRINT_BLACKWHITE&&response.PRINT_BLACKWHITE=='Y'){
								this.blackText=true;
							}else{
								this.blackText=false;
							}
							if(this.sharereportInfo.ORDER_NUM&&this.sharereportInfo.ORDER_NUM.length>0){
								let inputJson2={"PROCEDURE":"geterisreportlinks","USER_ID":parseInt(this.userId),"ORDER_NUM":response.ORDER_NUM};
								let result= await this.reportService.univeralService(JSON.stringify(inputJson2)).toPromise();
									//console.log(result);
									if (result.RESPONSE_STATUS=='N') {
										this.throwError(result)
										return										
									}
									this.sharepdfs=result.REPORT_LINKS;
																
								
								let inputJson6={"PROCEDURE":"geterisproducts","USER_ID":parseInt(this.userId),"ORDER_NUM":response.ORDER_NUM};console.log(inputJson6);
								let result2= await this.reportService.univeralService(JSON.stringify(inputJson6)).toPromise();
								if (result2.RESPONSE_STATUS=='N') {
									this.throwError(result2)
									return										
								}
								this.shareerisPdfs=result2.PRODUCT_LINKS;
								
							}
							let inputJson4= {"PROCEDURE":"getreportappendix","USER_ID":parseInt(this.userId),"REPORT_ID":id};
							let result3= await this.reportService.univeralService(JSON.stringify(inputJson4)).toPromise();
							if (result3.RESPONSE_STATUS=='N') {
								this.throwError(result3)
								return										
							}
							if(result3.APPENDIX_DATA&&result3.APPENDIX_DATA.length>0){
								this.shareappendices=JSON.parse(result3.APPENDIX_DATA);//console.log(this.appendices);
							}
							
				this.toprintIndex++;
				if(this.shareappendices.SUB_SECTIONS.length>0){
					this.sharepdfType={'index':this.toprintIndex, 'type':'app'};
				}else{
					this.sharepdfType={'index':this.toprintIndex, 'type':''};
				}
				
			
			}else{
				this.noPrint=false;
				Swal.fire({
					icon:'info',
					text: 'Report has no data',
			
				})
			}
		}
	}
	searchDateButtonColor = 'rgb(9 17 33)'
	hoverDateSearchButton(){
		this.searchDateButtonColor = '#C2D63F'
		// console.log('C2D63F')
	}
	leaveDateSearchButton(){
		this.searchDateButtonColor = 'rgb(9 17 33)'
	}
	keywordSearchButtonColor = 'rgb(9 17 33)'
	hoverKeywordSearchButton(){
		this.keywordSearchButtonColor = '#C2D63F'
		// console.log('C2D63F')
	}
	leaveKeywordSearchButton(){
		this.keywordSearchButtonColor = 'rgb(9 17 33)'
	}
	resetEmailForm(){
		this.shareEmail = ''
	}
	sideNavWidth = '66px'
	toggleSideBarVar = false
	toggleSideBar(){
		if(this.toggleSideBarVar == false) {
			this.sideNavWidth = '400px'
			this.toggleSideBarVar = true
		} else if(this.toggleSideBarVar == true) {
			this.sideNavWidth = '66px'
			this.toggleSideBarVar = false

		}

	}
	googleMap2:google.maps.Map;
	infoWindow2=null;
	marker2:any;
	noLocation = true;
	zoomV=18;
	address
	getCords(user){
		console.log("cords", user.LONGITUDE, user.LATITUDE)
		if(!user.LATITUDE || !user.LONGITUDE){
		let list=[user.ADDRESS_LINE1, user.ADDRESS_LINE2, user.CITY, user.PROVSTATE, user.POSTALZIP, user.COUNTRY]
		let list1=[]
		for(var i in list){
			if(list[i]!=''){
				list1.push(list[i])
			}
		}
		let address=user.FULL_ADDRESS
			let content:any;
				content= {'address': address};
				
			console.log("getAddress", content);
			
		this.geoCoder.geocode(content, (results, status) => {
		 // console.log(results);
		 // console.log(status);
		  //console.log("valid", list1.length)
		  if (status === 'OK' && (results[0].geometry.location_type=="ROOFTOP" || results[0].types=="street_address") && list1.length>=2) {
			 //console.log("valid", results[0].geometry.location_type)
			 //console.log("valid", results[0].types)
			if (results[0]) {
				console.log("geocodedone");
			  //this.zoom = 12;
			  this.address = results[0].formatted_address; //console.log(this.address);
			  this.ngZone.run(()=>{
				user.LATITUDE = results[0].geometry.location.lat();
				user.LONGITUDE = results[0].geometry.location.lng();
				this.noLocation = true;
				this.zoomV=18;
			  })
		
			} else {
			//  window.alert('No results found');
			user.LATITUDE=48.3552518;
			user.LONGITUDE=-100.0036572;
			this.noLocation = false;
			this.zoomV = 3;
			//console.log("valid", results[0].geometry.location_type)
			//console.log("valid", results[0].types)
			}
		  } else {
			//window.alert('Geocoder failed due to: ' + status);
			user.LATITUDE=48.3552518;
			user.LONGITUDE=-100.0036572;
			this.noLocation = false;
			this.zoomV = 3;
			console.log("valid", results[0].geometry.location_type)
			console.log("valid", results[0].types)
		  }
		});
		}else{
			if(user.LATITUDE==0 && user.LONGITUDE==0){
				user.LATITUDE=48.3552518;
				user.LONGITUDE=-100.0036572;
				this.noLocation = false;
				this.zoomV = 3;
			}
		}
		let latLng=new google.maps.LatLng(user.LATITUDE, user.LONGITUDE)
		var mapOptions = {
			mapTypeControl:false,
			center: latLng,
			zoom: this.zoomV,
			mapTypeId: google.maps.MapTypeId.ROADMAP,
			disableDoubleClickZoom: true,
			mapId: "DEMO_MAP_ID"
		};
		let that=this;
		setTimeout(() => {
			let ele= document.getElementById("googleMap2") ;
			if(!ele) return
			that.googleMap2 = new google.maps.Map(ele, mapOptions);
			if(!this.noLocation) return
			that.infoWindow2 = new google.maps.InfoWindow({position: latLng, content: '<span style="color:black; font-weight:bold">'+user.FULL_ADDRESS+'</span>'});
			//that.infoWindow2.open(that.googleMap2);
			let map2=that.googleMap2;
		that.marker2=new google.maps.Marker({
			map: map2,
			icon:'assets/images/Site_Marker.png',
			title: user.FULL_ADDRESS,
			position: { lat: user.LATITUDE, lng: user.LONGITUDE },
		})
		that.marker2.addListener("click", () => {
			that.infoWindow2 .open({
			  anchor: that.marker2,
			  map2,
			});
		  });
		
		}, 250);
		
		
	}
	onHide(){
		if (this.infoWindow2 !== null){
			this.infoWindow2.setMap(null);
			this.infoWindow2=null;
		} 	
		if (this.marker2 !== null){
			this.marker2.setMap(null);
			this.marker2=null;
		} 	
		this.googleMap2=null;
	}
	
	private throwError(data){
		if(data.RESPONSE_STATUS=='N'&&data.ERRORCODE == '9'){
			console.log('Timeout');
			Swal.fire({
				html: '<p style="font-size:16px; color:red">' + data.MESSAGE.replace('\\n', '<br>') + '</p>',
			})
			this.cookieService.clearAll();
			this.router.navigate(['/']);			
		}else{
			Swal.fire({
				html: '<p style="font-size:16px; color:red">' + data.MESSAGE.replace('\\n', '<br>') + '</p>',
			})
		}
	  }
	emailId="";
	showEmail(id){console.log(id)
		this.emailId=id
	}

	async _getCompanyGroupIndicator() {
		let getcompanyinfoJson = { "PROCEDURE": "getcompanyprofile", "USER_ID": parseInt(this.userId) };
		return new Promise<void>((resolve, reject) => {
			this.reportService.univeralService(JSON.stringify(getcompanyinfoJson)).subscribe(data => {
				if (data.RESPONSE_STATUS=='N') {
					this.throwError(data);
					reject();
				} else {
					this.companyGroupIndicator = data.COMPANY_GROUP_IND === 'Y' ? true : false;
					resolve();
				}
			});
		});
	}
}
